<template>
    <div style="position: relative;">
      <img class="img" src="../../../assets/a3/1.png" alt=""/>
      <img class="img" src="../../../assets/a3/2.png" alt="" @click="toWeChat" />
      <img class="img" src="../../../assets/a3/3.png" alt="" @click="toWeChat" />
      <div class="btn" @click="toLogin" ></div>
      <div class="float">
        <img class="img" src="../../../assets/a3/4.png" alt="" @click="toWeChat" />
        <div class="text">{{ weChatID }}</div>
      </div>
    </div>
  </template>
  
  <script>
  import clipboard from 'clipboard';
  export default {
    data() {
      return {
        weChatID : "yydj2025"
      };
    },
    methods: {
      toWeChat() {
        // 复制微信号到剪贴板
        clipboard.copy(this.weChatID);
  
        // 试图打开微信
        window.location.href = "weixin://";
      },
      toLogin(){
        //http://agent.yiyuanjianji.com/#/playlet?inviteCode=nmcj7y&shareById=33902
          this.$router.push({
            name: "playlet",
            query:{
                inviteCode:'nmcj7y',
                shareById:'33902'
            }
          })
      }
    },
  };
  </script>
  
  <style scoped>
  .img {
    display: block;
    width: 100%;
    max-width: 750px;
  }
  .float{
    position: fixed;
    bottom: 0px;
  }
  .btn{
    position: absolute;
    top: 12.95rem;
    width: 100%;
    max-width: 750px;
    height: 44px;
  }
  .text{
    position: absolute;
    font-size: 0.3rem;
    font-weight: 900;
    color: black;
    bottom: 0.3rem;
    left: 2.2rem;
  }
  </style>